import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor() {
    }


    saveSalesman(salesman: Sofi.Salesman) {
        sessionStorage.setItem('salesman', JSON.stringify(salesman));
    }

    getSalesman() {
        let salesmanJson = sessionStorage.getItem('salesman');
        if (salesmanJson) {
            return JSON.parse(salesmanJson);
        }
        return null;
    }

    saveUser(user: Sofi.User) {
        sessionStorage.setItem('user', JSON.stringify(user));
    }

    getUser = function (): Sofi.User {
        let userJson = sessionStorage.getItem("user");
        if (userJson) {
            return JSON.parse(userJson);
        }
        return null;
    };
}
